export const LIST_PATH = '/presupuesto-participativo-primera'
export const ACCOUNT_PATH = '/account'
export const LOGIN_PATH = '/login'
export const SIGNUP_PATH = '/signup'
export const PASSWORD_RESET_PATH = '/reset-password'
